import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { baseUrl } from "../../context/BaseUrl";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Suggestion = ({ handle }) => {
  // For Suggestion form

  const { show, setShow } = handle;

  const [Email, setEmail] = useState("");
  const [Name, setName] = useState("");
  const [Number, setNumber] = useState("");
  const [Message, setMessage] = useState("");

  const handleSent = async () => {
    const user = localStorage.getItem("user");

    if (!user) {
      toast.error("You are not logged in.");
      return;
    }

    const response = await fetch(
      `${baseUrl}/user/suggestion_form/post_suggestion`,
      {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: Email,
          name: Name,
          number: Number,
          description: Message,
        }),
      }
    );

    const result = await response.json();

    if (result.code == 500) {
      toast.error(result.msg);
      return;
    }

    toast.success(result.msg);
    setMessage("");
    setName("");
    setNumber("");
    setEmail("");

    setTimeout(() => {
      setShow(false);
    }, 500);
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <Modal
        show={show}
        onHide={() => setShow(!show)}
        className="suggestion-box"
      >
        <Modal.Header closeButton>
          <Modal.Title>Suggestion Box</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-4" controlId="FormInput">
              <Form.Control
                type="text"
                placeholder="Name"
                autoFocus
                onChange={(e) => setName(e.target.value)}
                value={Name}
              />
            </Form.Group>
            <Form.Group className="mb-4" controlId="FormInput">
              <Form.Control
                type="email"
                placeholder="Email"
                onChange={(e) => setEmail(e.target.value)}
                value={Email}
              />
            </Form.Group>
            <Form.Group className="mb-4" controlId="FormInput">
              <Form.Control
                type="text"
                placeholder="Phone Number"
                onChange={(e) => setNumber(e.target.value)}
                value={Number}
              />
            </Form.Group>
            <Form.Group className="mb-4" controlId="FormTextarea">
              <Form.Control
                as="textarea"
                rows={4}
                placeholder="Type Message"
                onChange={(e) => setMessage(e.target.value)}
                value={Message}
              />
            </Form.Group>
          </Form>

          <Button variant="primary" onClick={handleSent}>
            Send Suggestion
          </Button>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default Suggestion;
